export let vm;

export const setVm = _vm => (vm = _vm);
